// extracted by mini-css-extract-plugin
module.exports = {"overlay":"HighlightPopup_overlay__L0tkE"};